import { FileUpload } from 'primereact/fileupload';
import MenuBarComponent from '../Components/MenuBarComponent'
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useRef, useState } from 'react';
import AuthContext from '../Contexts/AuthContext';
import { Carousel } from 'primereact/carousel';
import { toast } from 'react-toastify';
import { deletePicturesService, getPictureLogoService, listPicturesByCreatedByService } from '../Service/ReligiousPlaceService';
import { Button } from 'primereact/button';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { Card } from 'primereact/card';

function PlacePictures() {
    const { t } = useTranslation('register_place');
    const {userAuth} = useContext(AuthContext)
    const [picturesInsertedLength, setPicturesInsertedLength] = useState(10);
    const fileUploadRef = useRef(null);
    const fileUploadLogoRef = useRef(null);

    const [pictureLogo, setPictureLogo] = useState();
    const [picturesInserted, setPicturesInserted] = useState();
    const responsiveOptions = [
        {
            breakpoint: '1400px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '1199px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 1,
            numScroll: 1
        },
        {
            breakpoint: '575px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    useEffect(()=>{
        listPicturesByCreatedBy()
        getPictureLogo()
    },[])

    const listPicturesByCreatedBy = () => {
        userAuth?.user?.access_key && listPicturesByCreatedByService(userAuth?.user?.access_key).then((res)=>{
            if (res){
                setPicturesInserted(res)
                setPicturesInsertedLength(res.length)
            }
        })
    }

    const getPictureLogo = () => {
        userAuth?.user?.access_key && getPictureLogoService(userAuth?.user?.access_key).then((res)=>{
            res && setPictureLogo(res)
        })
    }

    const onUpload = async ({ files }) => {
        if (files.length + picturesInsertedLength > 10){
            toast.error(t('place_pictures_images_length_validation'))
            return
        }
        const formData = new FormData();
        formData.append('user_access_key', userAuth?.user?.access_key);
        formData.append('is_logo', false);

        // Append all files
        Array.from(files).forEach(file => {
            formData.append('images', file);
        });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/religious_place_picture/upload_images`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();
            
            if (response.ok) {
                listPicturesByCreatedBy()
                toast.success(t('place_pictures_images_saved'));
            } else {
                throw new Error(data.error || 'Upload failed');
            }
        } catch (error) {
            toast.error(error.message)
        } finally {
            fileUploadRef.current.clear();
        }
    };

    const onUploadLogo = async ({ files }) => {
        if (pictureLogo){
            return
        }
        const formData = new FormData();
        formData.append('user_access_key', userAuth?.user?.access_key);
        formData.append('is_logo', true);

        // Append all files
        Array.from(files).forEach(file => {
            formData.append('images', file);
        });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/religious_place_picture/upload_images`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();
            
            if (response.ok) {
                getPictureLogo()
                toast.success(t('place_pictures_logo_saved'));
            } else {
                throw new Error(data.error || 'Upload failed');
            }
        } catch (error) {
            toast.error(error.message)
        } finally {
            fileUploadLogoRef.current.clear();
        }
    };

    const handlePictureDelete = (id, filename) => {
        confirmDialog({
            message: t('place_pictures_delete_message'),
            header: t('place_pictures_delete_confirmation'),
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept:()=>{
                deletePicturesService(id, filename).then((res)=>{
                    res === true && toast.success(t('place_pictures_place_images_deleted_message'))
                    listPicturesByCreatedBy()
                })
            },
            reject:()=>{}
        });
    }

    const handleLogoDelete = (id, filename) => {
        confirmDialog({
            message: t('place_pictures_delete_logo_message'),
            header: t('place_pictures_delete_confirmation'),
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept:()=>{
                deletePicturesService(id, filename).then((res)=>{
                    if (res === true) {
                        toast.success(t('place_pictures_place_logo_deleted_message'))
                        setPictureLogo()
                    }
                })
            },
            reject:()=>{}
        });
    }

    const pictureTemplate = (picture) => {
        return (
            <div className="border-1 surface-border border-round m-2 text-center py-5 px-3">
                <img src={`https://storage.googleapis.com/religious_place_images/${picture.picture_url}`} alt={picture.picture_url} className="md:h-10rem h-5rem shadow-2" />
                <div>
                    <Button icon={'pi pi-trash'} severity='danger' size='small' onClick={()=>handlePictureDelete(picture.id, picture.picture_url)} />
                </div>
            </div>
        );
    };
    
    return (
        <div className=''>
            <ConfirmDialog />
            <div className='flex flex-column p-2 gap-2 md:p-4 md:gap-4'>
                <div className='flex flex-column gap-2'>
                    <Card title={t('place_pictures_place_logo_title')}>
                    {pictureLogo && 
                        <div className='flex justify-content-center'>
                            <div className="border-1 surface-border border-round m-2 w-min text-center py-5 px-3">
                                <img src={`https://storage.googleapis.com/religious_place_images/${pictureLogo.picture_url}`} alt={pictureLogo.picture_url} className="h-5rem w-min shadow-2" />
                                <Button icon={'pi pi-trash'} severity='danger' size='small' onClick={()=>handleLogoDelete(pictureLogo.id, pictureLogo.picture_url)} />
                            </div>
                        </div>}
                    </Card>

                    {!pictureLogo && <FileUpload ref={fileUploadLogoRef} name="images" url={`${process.env.REACT_APP_API_URL}/api/religious_place_picture/upload_images`} 
                    accept="image/*" maxFileSize={1000000} emptyTemplate={<p className="m-0">{t('place_pictures_upload_instructions')}</p>} 
                    uploadHandler={onUploadLogo} customUpload />}
                </div>
                <div className='flex flex-column gap-2'>
                    <Card title={t('place_pictures_place_images_title')}>
                        {picturesInserted && <Carousel circular value={picturesInserted} numVisible={2} numScroll={1} responsiveOptions={responsiveOptions} itemTemplate={pictureTemplate} />}
                    </Card>
                    


                    {picturesInserted && picturesInserted.length < 10 && <FileUpload ref={fileUploadRef} name="images" url={`${process.env.REACT_APP_API_URL}/api/religious_place_picture/upload_images`} multiple 
                    accept="image/*" maxFileSize={1000000} emptyTemplate={<p className="m-0">{t('place_pictures_upload_instructions')}</p>} 
                    uploadHandler={onUpload} customUpload />}
                </div>
            </div>
        </div>
    )
}

export default PlacePictures